import React from 'react';
import { useTranslation } from 'react-i18next';
import { createPlaceholderUrl } from '../../../utils/PlaceholderCreator';
import { API_BASE_URL } from '../../../constants';

const CharacterImageDisplay = ({ character, card }) => {
    const { t } = useTranslation();

    const placeholderUrl = createPlaceholderUrl(800, 1067, 'Character', '#E0E0E0', '#AAAAAA');

    let imageUrl = placeholderUrl;
    let altText = "Character image";

    const sanitizeFilename = (name) => {
        if (typeof name !== 'string') return '';
        return name.replace(/[\\/*?:"<>|]/g, '');
    };

    if (character && card) {
        altText = card.title_en || character.name_en;
        try {
            const characterName = sanitizeFilename(character.name_en).replace(/ /g, '_');
            const reference = sanitizeFilename(card.reference).replace(/ /g, '_');
            const costumeName = sanitizeFilename(card.title_en).replace(/ /g, '_');


            const imageName = `${characterName}_${reference}_${costumeName}.png`;
            imageUrl = `${API_BASE_URL}/api/thumb?img=/images/character/${imageName}&width=512`;
        } catch (error) {
            console.error("Could not construct image URL for:", altText, error);
            imageUrl = placeholderUrl;
        }
    }

    return (
        <div className="bg-card-white rounded-2xl shadow-xl p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">{t('CharacterImageDisplay.title')}</h2>
            <div className="relative w-full">
                <img
                    src={imageUrl}
                    alt={altText}
                    key={card ? card.card_id : 'placeholder'}
                    className="w-full aspect-square object-contain rounded-lg"
                    onError={(e) => {
                        e.target.src = placeholderUrl;
                    }}
                />
            </div>
            {card && (
                <div className="mt-4 text-center">
                    <p className="font-semibold text-gray-800">{card.title_en}</p>
                    {card.title_ja && (
                        <p className="text-sm text-gray-600">{card.title_ja}</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default CharacterImageDisplay;
// Revisado: 2025-12-18 [I18n Scan]
